
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";



import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextBox from '../../uic/controls/BiTextBox';
import BiLabel from '../../uic/controls/BiLabel';

import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import BiTextArea from "../../uic/controls/BiTextArea";
import useFetch from "../../helpers/useFetch";
import BiComboBox from "../../uic/controls/BiComboBox";
import BiAutoCB from "../../uic/controls/BiAutoCB";
import BiFileUpload from "../../uic/controls/BiFileUpload";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid";

const KultureObrazec = ({
    idObrazca,
    obrazec,
    onObrazecChanged,
    onObrazecCBListChanged,
    onObrazecTableChange,
    admin,
    disabled,
    onObrazecDatotekeAdd,
    onObrazecDatotekeRemove

}) => {

    const cellStyleKolicinaFun = (item) => {
        if (item.kolicinaKontrola != item.kolicinaStranka && admin == true) {
            return { color: "red", borderRight:"2px solid red" };
        }
        return null;
    }

    const disabledFun = () => {
        return disabled;
    }

    return (

        <Fragment >

            {obrazec &&


                <form className="form">


                    <BiFormTable responsive={true} columns={[
                        { width: "col-lg-2" },
                        { width: "col-lg-6" },
                        { width: "col-lg-2" },
                    ]}>
                        {admin &&
                            <BiFormSection responsive={true} show={true} label="Osnovni podatki" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                   <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-user">Obdelal:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox name="potrdil" disabled={true} value={obrazec.potrdil} onChange={onObrazecChanged} ></BiTextBox>

                                    </BiFormCell>
                                </BiFormRow>
                                
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fas fa-book-reader">Naziv:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled="true" name="naziv" value={obrazec.nazivStranke} onChange={onObrazecChanged} ></BiTextBox>

                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                
                            </BiFormSection>
                        }
                        {obrazec.kulture.length != 0 &&
                            <BiFormSection responsive={true} show={true} label="Vnos kultur" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-lg-12" >
                                        <div style={{ minHeight: "160px" }} >
                                            <BiDataGrid
                                                items={obrazec.kulture}
                                                name="kulture"
                                                mainKey="pIdKolicineObrazecKulture"
                                                onSelectedItemChanged={onObrazecTableChange}
                                                columns={[
                                                    { label: "ID", key: "pIdKolicineObrazecKulture", type: "decimal", width: "50px" },
                                                    { label: "Kultura", key: "kultura", type: "string", width: "100%" },
                                                    //{ label: "Količina ob kontroli", key: "kolicinaKontrola", type: "decimal", width: "140px", format: "0.00[0000]", align: "right", cellStyleFun: cellStyleKolicinaFun },
                                                    { label: "Količina dejanska", key: "kolicinaStranka", type: "decimal", width: "130px", format: "0.00[0000]", align: "right", editable: !disabled, cellStyleFun: cellStyleKolicinaFun },
                                                    { label: "Status", key: "status", type: "string", width: "60px", align: "right" },

                                                ]}

                                            ></BiDataGrid>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                            </BiFormSection>
                       }
                        <BiFormSection responsive={true} show={true} label="Vnos proizvodov" icon="fas fa-calendar-plus" >
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} col="col-lg-12" >
                                    <BiDataGrid
                                        items={obrazec.proizvodi}
                                        name="proizvodi"
                                        mainKey="pIdKolicineObrazecProizvodi"
                                        onSelectedItemChanged={onObrazecTableChange}
                                        columns={[
                                            { label: "ID", key: "pIdKolicineObrazecProizvodi", type: "decimal", width: "50px" },
                                            { label: "Proizvod", key: "proizvod", type: "string", width: "100%" },
                                            //{ label: "Količina ob kontroli", key: "kolicinaKontrola", type: "decimal", width: "140px", format: "0.00[0000]", align: "right", cellStyleFun: cellStyleKolicinaFun },
                                            { label: "Količina dejanska", key: "kolicinaStranka", type: "decimal", width: "130px", format: "0.00[0000]", align: "right", editable: !disabled, cellStyleFun: cellStyleKolicinaFun},
                                            { label: "Status", key: "status", type: "string", width: "60px", align: "right" },

                                        ]}

                                    ></BiDataGrid>

                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                        </BiFormSection>

                        <BiFormSection responsive={true} show={true} label="Opombe" icon="fas fa-comment" >
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} col="col-lg-12" >
                                    <BiTextArea maxlength="4000" disabled={disabled} name="opomba" value={obrazec.opomba} onChange={onObrazecChanged}></BiTextArea>

                                </BiFormCell>
                            </BiFormRow>
                        </BiFormSection>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                    </BiFormTable>
                </form>


            }
        </Fragment>
    );

}

export default KultureObrazec;